import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { forkJoin, fromEvent, ReplaySubject, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, last, map, switchMap, tap } from 'rxjs/operators';
import { DeleteAlertComponent } from 'src/app/shared/global_components/delete-alert/delete-alert.component';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LanguageService } from 'src/app/shared/services/common/language.service';
import { CompanyService } from 'src/app/shared/services/rest/company.service';
import { TaskService } from 'src/app/shared/services/rest/task.service';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { RefreshService } from 'src/app/shared/services/rest/refresh.service';
import { ParametersService } from 'src/app/shared/services/rest/parameters.service';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { SnackBarItem } from 'src/app/shared/global_components/snack-bar/snack-bar-item';
import { ScenariosService } from 'src/app/shared/services/rest/scenarios.service';
import * as moment from 'moment';
import { OpenTaskComponent } from 'src/app/components/workspace-pages/cases/dialogs/open-task/open-task.component';
import { ChatService } from 'src/app/shared/services/rest/chat.service';
import { FileService } from 'src/app/shared/services/rest/file.service';
import { OpenJobComponent } from 'src/app/components/workspace-pages/cases/dialogs/open-job/open-job.component';
import { casesModel } from 'src/app/shared/functions/casesModel';
import { AuthService } from 'src/app/shared/services/rest/auth.service';
import { MY_FORMATS } from 'src/app/components/workspace-pages/cases/dialogs/open-task/dialogs/add-task-profile/add-task-profile.component';

@Component({
  selector: 'app-scenarios-queue',
  templateUrl: './scenarios-queue.component.html',
  styleUrls: ['./scenarios-queue.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class ScenariosQueueComponent extends BaseClass implements OnInit, OnDestroy {
  public page: number = 1;
  public pagination: any;
  public scenarios: any[] = [];
  public scenarioNames: any[] = [];
  public company_id: number = +this.activatedRoute.snapshot.queryParamMap.get('company_id');
  public is_mobile: boolean = false;
  public isLoad: boolean = false;
  public company: any;
  public user: any;
  public activeLang: any;
  public operations: any;
  public sortValue: any = '';

  public scenariosFilter: FormGroup = this.fb.group({
    template_id: "",
    is_active: "",
    is_in_queue: "",
    is_running: "",
    is_interval: "",
    is_resident: "",
    scenario_name: "",
    task_id: "",
    task_operation_id: "",
    executed_at_from: "",
    executed_at_to: "",
    queued_at_from: "",
    queued_at_to: "",
    checked_at_from: "",
    checked_at_to: ""
  })

  throttle = 100;
  scrollUpDistance = 3.5;

  public openJobSub: Subscription;
  public loadSub: Subscription;

  public today = moment().set({hour:0,minute:0,second:0}).unix();
  public todayEnd = moment().endOf('day').unix();
  
  constructor(
    private taskService: TaskService,
    private fb: FormBuilder,
    private router: Router,
    private layoutService: LayoutService,
    private languageService: LanguageService,
    private chatService: ChatService,
    private scenariosService: ScenariosService,
    private fileService: FileService,
    private dialog: MatDialog,
    private _adapter: DateAdapter<any>,
    private activatedRoute: ActivatedRoute,
    private auth: AuthService,
    private companyService: CompanyService,
    private bottomSheet: MatBottomSheet
  ) { super() }

  ngOnInit(): void {
    this.checkIsMobile();
    this.getLangData();
    this.getCompany();
    this.getScenarioNames();
    this.getOperations();
    this.getUser();
    this.attachSubscriptions(
      this.activatedRoute.queryParams.subscribe(params => {
        console.log("route scenarios", params);

        this.sortValue = this.activatedRoute.snapshot.queryParamMap.get('order_by') || ''
        this.scenariosFilter.patchValue({
          template_id: !!this.activatedRoute.snapshot.queryParamMap.get('template_id') ? this.activatedRoute.snapshot.queryParamMap.get('template_id') : "",
          is_active: this.activatedRoute.snapshot.queryParamMap.get('is_active') !== '' && this.activatedRoute.snapshot.queryParamMap.get('is_active') !== null ? +this.activatedRoute.snapshot.queryParamMap.get('is_active') : "",
          is_in_queue: this.activatedRoute.snapshot.queryParamMap.get('is_in_queue') !== '' && this.activatedRoute.snapshot.queryParamMap.get('is_in_queue') !== null ? +this.activatedRoute.snapshot.queryParamMap.get('is_in_queue') : "",
          is_running: this.activatedRoute.snapshot.queryParamMap.get('is_running') !== '' && this.activatedRoute.snapshot.queryParamMap.get('is_running') !== null ? +this.activatedRoute.snapshot.queryParamMap.get('is_running') : "",
          is_interval: this.activatedRoute.snapshot.queryParamMap.get('is_interval') !== '' && this.activatedRoute.snapshot.queryParamMap.get('is_interval') !== null ? +this.activatedRoute.snapshot.queryParamMap.get('is_interval') : "",
          is_resident: this.activatedRoute.snapshot.queryParamMap.get('is_resident') !== '' && this.activatedRoute.snapshot.queryParamMap.get('is_resident') !== null ? +this.activatedRoute.snapshot.queryParamMap.get('is_resident') : "",
          scenario_name: !!this.activatedRoute.snapshot.queryParamMap.get('scenario_name') ? this.activatedRoute.snapshot.queryParamMap.get('scenario_name') : "",
          task_id: !!this.activatedRoute.snapshot.queryParamMap.get('task_id') ? this.activatedRoute.snapshot.queryParamMap.get('task_id') : "",
          task_operation_id: !!this.activatedRoute.snapshot.queryParamMap.get('task_operation_id') ? this.activatedRoute.snapshot.queryParamMap.get('task_operation_id') : "",
          executed_at_from: !!this.activatedRoute.snapshot.queryParamMap.get('executed_at_from') ? moment(+this.activatedRoute.snapshot.queryParamMap.get('executed_at_from')*1000).utc() : "",
          executed_at_to: this.activatedRoute.snapshot.queryParamMap.get('executed_at_to') == '0' ? 0 : (!!this.activatedRoute.snapshot.queryParamMap.get('executed_at_to') ? moment(+this.activatedRoute.snapshot.queryParamMap.get('executed_at_to')*1000).utc() : ""),
          queued_at_from: !!this.activatedRoute.snapshot.queryParamMap.get('queued_at_from') ? moment(+this.activatedRoute.snapshot.queryParamMap.get('queued_at_from')*1000).utc() : "",
          queued_at_to: this.activatedRoute.snapshot.queryParamMap.get('queued_at_to') == '0' ? 0 : (!!this.activatedRoute.snapshot.queryParamMap.get('queued_at_to') ? moment(+this.activatedRoute.snapshot.queryParamMap.get('queued_at_to')*1000).utc() : ""),
          checked_at_from: !!this.activatedRoute.snapshot.queryParamMap.get('checked_at_from') ? moment(+this.activatedRoute.snapshot.queryParamMap.get('checked_at_from')*1000).utc() : "",
          checked_at_to: this.activatedRoute.snapshot.queryParamMap.get('checked_at_to') == '0' ? 0 : (!!this.activatedRoute.snapshot.queryParamMap.get('checked_at_to') ? moment(+this.activatedRoute.snapshot.queryParamMap.get('checked_at_to')*1000).utc() : ""),
        })
        this.scenarios = [];
        this.page = 1;
        this.getScenarios(this.page)
      })
    )

  }

  sort(val) {
    this.filterScenarios(val)
  }

  getScenarioNames() {
    this.attachSubscriptions(
      this.scenariosService.getCardScenarioTypes().subscribe(resp => {
        this.scenarioNames.push(...resp);
      })
    )
    this.attachSubscriptions(
      this.scenariosService.getAutomationTemplatesTypes().subscribe(resp => {
        this.scenarioNames.push(...resp);
      })
    )
  }

  getUser() {
    this.attachSubscriptions(
      this.auth.$user.subscribe(resp => {
        this.user = resp;
      })
    )
  }

  checkIsMobile() {
    if (window.innerWidth <= 769) {
      this.is_mobile = true;
    } else {
      this.is_mobile = false;
    }
    this.onResize();
  }

  onResize() {
    this.attachSubscriptions(
      fromEvent(window, "resize").pipe(
        map(() => window.innerWidth)
      ).subscribe((wWidth) => {
          if (wWidth <= 769) {
            this.is_mobile = true;
          } else {
            this.is_mobile = false;
          }
        }
      )
    )
  }

  neededCardData(task) {
    let arr = [
      this.chatService.getTasksChats(this.company_id, [task.id]).pipe(
        tap(res => {
          task['operations'].map(o_el => {
            o_el['chatsInfo'] = [];
            o_el['chatsInfo'].push(...res.filter(z => z.task_operation_id == o_el.id));
            o_el['unReadChats'] = res.filter(z => z.task_operation_id == o_el.id && z.is_read != '1').length;
            o_el['unClosedChats'] = res.filter(z => z.task_operation_id == o_el.id && z.status_id != '4').length;
          });
          task['chatsInfo'] = [];
          task['chatsInfo'].push(...res.filter(z => z.task_id == task.id));
          task['unReadChats'] = res.filter(z => z.is_read != '1').length;
          task['unClosedChats'] = res.filter(z => z.status_id != '4').length;
        })
      )
    ]
    if (task.company_id == this.company_id) {
      arr.push(
        this.taskService.getTaskClients(task.id, this.company_id).pipe(
          tap(res => {
            task.clients = res
          }),
          catchError(err => {
            return err
          })
        )
      )
    }
    arr.push(...task.operations.filter(z => (z.status_id == 3 && z.is_to_approve_files) || (z.status_id == 98 && z.is_approved_files)).map(x => this.fileService.getFilesForOpenTask(this.company_id, x.id, x.status_id == 3 ? '/to_approve' : '/ready_files').pipe(
      tap(val => {
        x.filesCount = val.headers.get('x-pagination-total-count')
        x.files = val.body
      })
    )))

    return forkJoin(arr)
  }

  openJob(item, task_operation_id) {
    let task_id = 0;

    if (item.jobLoad) {
      return;
    }

    if (this.openJobSub) {
      this.openJobSub.unsubscribe();
    }

    item.jobLoad = true;
    this.openJobSub = this.taskService.getWork(task_operation_id).pipe(
      switchMap(workData => {
        task_id = workData.task_id;
        return this.taskService.getOneTaskExpand(this.company.id, task_id).pipe(
          map(x => x.body[0]),
          switchMap(x => this.neededCardData(x).pipe(map(() => casesModel([x], [], 'update')),map(x => x.arr[0]))),
        )
      })
    ).subscribe(resp => {
      item.jobLoad = false;
      const dialogRef = this.dialog.open(OpenJobComponent, {
        backdropClass: 'backdrop_under_header',
        panelClass: !this.is_mobile ? ['open_task_dialog', 'show_header'] : 'open_task_dialog',
        autoFocus: false,
        data: {
          task_id: task_id,
          task_operation_id: task_operation_id,
          task: resp,
          initCompanyId: this.company.id,
        }
      });
    })
  }

  openTask(item, task_id) {

    if (item.cardLoad) {
      return;
    }

    item.cardLoad = true;
    let taskData:any = {
      task_id: task_id,
      initCompanyId: this.company.id
    }
    const dialogRef = this.dialog.open(OpenTaskComponent, {
      backdropClass: 'backdrop_under_header',
      panelClass: !this.is_mobile ? ['open_task_dialog', 'show_header'] : 'open_task_dialog',
      autoFocus: false,
      data: taskData
    });
    item.cardLoad = false;
  }
  
  removeValue(val) {
    if (val == "all") {
      let params = {
        company_id: this.company_id,
        page: this.activatedRoute.snapshot.queryParamMap.get('page')
      }
      this.router.navigate(['/settings'], {queryParams: params})
    } else {
      let params = {...this.activatedRoute.queryParamMap.source['_value']}
      if (params[val]) {
        delete params[val]
      }

      this.router.navigate(['/settings'], {queryParams: params})
    }
  }

  changeAutoCheckTag(e, check) {
    console.log("changeAutoCheckTag", e, check);
    this.attachSubscriptions(
      this.taskService.editOperationReminder(check.id, {file_parameter_value_id: e.value}).subscribe(resp => {
        console.log("changeAutoCheckTag resp", resp);
      }, error => {
        this.layoutService.showSnackBar({name: ''}, error, SnackBarItem)
      })
    )
  }

  resetFil(key) {
    this.scenariosFilter.patchValue({
      [key+'_at_from']: '',
      [key+'_at_to']: ''
    })

    this.filterScenarios()
  }

  onStartDateChange(e) {
    console.log("onStartDateChange", e)
    this.log();
    this.filterScenarios();
  }

  onEndDateChange(e) {
    console.log("onEndDateChange", e)
    this.log()
    this.filterScenarios();
  }

  log() {
    console.log("scenariosFilter", this.scenariosFilter.value)
    console.log("scenarios", this.scenarios)
  }

  getScenarios(page) {
    if (this.isLoad) {
      return
    }
    this.isLoad = true;
    let filterData = {...this.scenariosFilter.value};

    filterData.page = page;
    filterData.order_by = this.sortValue;


    Object.keys(filterData).forEach(key => {
      if (filterData[key] === '') {
        delete filterData[key];
      } else {
        if (key.indexOf('_at_') != -1 && filterData[key]._d) {
          filterData[key] = moment(filterData[key]._d).format("X");
        }
      }
    })

    if (this.loadSub) {
      this.loadSub.unsubscribe();
    }
    console.log(filterData)

    this.loadSub = this.scenariosService.getAutomationScenariosList(this.company_id, filterData, '40').pipe(
      tap(el => {
        this.pagination = {
          'pageCount': el.headers.get('x-pagination-page-count'),
          'perPage': el.headers.get('x-pagination-per-page'),
          'totalCount': el.headers.get('x-pagination-total-count'),
          'currentPage': el.headers.get('x-pagination-current-page'),
        }
      }),
      map(el => el.body)
    ).subscribe(resp => {
      console.log('getChecklist', resp)
      if (this.page == 1) {
        this.scenarios = resp;
      } else {
        this.scenarios.push(...resp);
      }
      console.log('scenarios page - ' + this.page, this.scenarios);
      this.page = this.page + 1;
      this.isLoad = false;
    }, error => {
      this.isLoad = false;
    })
  }

  getType(id) {
    if (!this.operations || !this.operations.find(el => el.id == id)) {
      return false;
    }
    return this.operations.find(el => el.id == id)
  }  

  getOperations() {
    this.attachSubscriptions(
      this.taskService.getOperations(this.company_id).subscribe(resp => {
        resp.unshift({
          id: 0,
          name: marker('All types')
        })
        this.operations = resp;
      })
    )
  }

  filterReset() {
    this.scenariosFilter.patchValue({
      template_id: "",
      is_active: "",
      is_in_queue: "",
      is_running: "",
      is_interval: "",
      is_resident: "",
      scenario_name: "",
      task_id: "",
      task_operation_id: "",
    })
    this.router.navigate(['/settings'], { queryParams: {page: 'scenarios_queue', company_id: this.company_id}});
  }

  getCompany() {
    this.attachSubscriptions(
      this.companyService.getCompany(this.company_id).subscribe(resp => {
        console.log("getCompany", resp);
        this.companyService.company$.next(resp[0]);
        this.company = resp[0];
        // if (this.company.permissions.includes('owner') || this.company.permissions.includes('manager') || this.company.permissions.includes('admin')) {
        //   this.displayedColumns.push(...["Tag", "Auto set", "Activity"])
        // }
      })
    )
  }

  goBack(e) {
    e.preventDefault();
    history.back();
  }

  filterScenarios(sort?) {
    let params:any = {
      company_id: this.company_id,
      page: 'scenarios_queue'
    };

    if (sort) {
      params.order_by = sort
    }

    Object.keys(this.scenariosFilter.value).forEach(element => {
      if (element.indexOf('_at_') != -1) {
        if (element.indexOf('at_from') != -1 && !!this.scenariosFilter.value[element]) {
          params[element] = moment(this.scenariosFilter.value[element]._d).clone().startOf('day').format("X");
        }
        if (element.indexOf('at_to') != -1 && !!this.scenariosFilter.value[element]) {
          params[element] = moment(this.scenariosFilter.value[element]._d).clone().endOf('day').format("X");
        }
      } else {
        if (this.scenariosFilter.value[element] !== '') {
          params[element] = this.scenariosFilter.value[element]
        }
      }
    });

    console.log("params", params);

    this.router.navigate(['/settings'], { queryParams: params});
  }

  onDownScenarios(e) {
    console.log("SCROLL DOWN", e);
    if (this.pagination['pageCount'] >= this.page) {
      console.log("onDownCompany")
      this.getScenarios(this.page);
    }
  }

  getLangData() {
    this.attachSubscriptions(
      this.languageService.getLangData().subscribe(resp => {
        this.activeLang = resp.active;
        this._adapter.setLocale(resp.active);
      })
    )
  }

  ngOnDestroy() {
    if (this.openJobSub) {
      this.openJobSub.unsubscribe();
    }
    if (this.loadSub) {
      this.loadSub.unsubscribe();
    }
    this.clearSubscriptions()
  }
}
